 <button mat-icon-button [mat-dialog-close]="true" type="button" style="float:right">
    <mat-icon>close</mat-icon>
</button>

<div style="width:100%;height:95%;overflow: auto;">
    <img src="{{data}}">
</div>